
import React, { Component } from 'react';
import PubSub from 'pubsub-js';
import { Input, message,Upload } from "antd";
import './createAreaPage.less';
import imageCompression from "browser-image-compression";
import close_btn from '../../../imgs/btn/close_btn.png';
import default_map from '../../../imgs/bg/default_map.png'
import area from "../../../imgs/item/area.png";
import upload_img from "../../../imgs/btn/upload_img.png";
import { meshLog, SPGet } from '../../../utils/spUtils';
import { getSelectBuildingUUID, judgeMeshNameExist } from '../../../utils/meshUtils';
import { createNewMesh, updateCurMesh } from '../../../utils/net/netUtils';
import { SPIN_DIALOG_HIDE, SPIN_DIALOG_SHOW, Upload_Mesh } from '../../../const/infoConst';
import { uploadFileImg } from '../../../utils/net/netManager';

let isLoad=0; //0未上传 1-已上传 2-创建area并上传
let loadFile;
let isNew=true;
let cur_mesh;
export default class CreateAreaPage extends Component {   
    constructor(props) {
        super(props);
        this.state = {
            mTitle:"",
            ui_mesh: "",
            load_img:default_map,
        };
    }

    componentDidMount() {
        PubSub.subscribe('changeMeshUpdateUI', (msg, data) => {
            meshLog('图片,isLoad=',isLoad);
            if(isLoad==2 && loadFile.size>0){
                isLoad=0;
                meshLog('图片开始上传',loadFile.size);
                uploadFileImg(loadFile);
            }
        })

        PubSub.subscribe('update_area_data_ui', (msg, data) => {
            meshLog('update_area',data);
            if(data==""){
                isNew=true;
                this.setState({
                    mTitle:"Create a Area Floor Plan",
                    ui_mesh: "",
                    load_img:default_map,
                })
            }else{
                isNew=false;
                cur_mesh=data; 
                this.setState({
                    mTitle:"Update Area Floor Plan",
                    ui_mesh: cur_mesh.meshName,
                    load_img:default_map,
                })
            }

        })

    }
    //上传图片
    beforeUpload=(file)=> {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg'|| file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error({content:'You can only upload JPG/PNG file!',style:{fontSize:"25px"}});
            meshLog('图片格式错误');
            return;
        }
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
            message.error({content:'Image must smaller than 10MB!',style:{fontSize:"25px"}});
            meshLog('图片大小错误');
            return;
        }
        meshLog('上传图片');
        isLoad=1;
        // loadFile=file;
        this.compressImg(file);
    };
    handleUploadChange=(file) => {
        
    };

    compressImg= async(file)=>{
        if(file.size / 1024 / 1024 < 2){
            this.loadFileImg(file);
            return;
        }

        PubSub.publish(SPIN_DIALOG_SHOW, '');//加载框
        try {
            // 压缩选项
            const options = {
                maxSizeMB: 2, // 最大文件大小（MB）
                maxWidthOrHeight: 1340, // 最大宽或高
                useWebWorker: true, // 使用 Web Worker 加速压缩
            };
            // 压缩图片
            const compressedFile = await imageCompression(file, options);
            meshLog("图片压缩成功");
            PubSub.publish(SPIN_DIALOG_HIDE, '');//加载框
            // 返回压缩后的文件
            this.loadFileImg(compressedFile);
            
        } catch (error) {
            meshLog("图片压缩失败！",error);
            PubSub.publish(SPIN_DIALOG_HIDE, '');//加载框
            this.loadFileImg(file);
        }
    };

    //加载预览图
    loadFileImg(file){
        loadFile=file;
        // 使用 FileReader 读取文件内容
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const dataUrl = reader.result;
            this.setState({ load_img:dataUrl, });
            meshLog('加载图片成功');
        };
        reader.onerror = () => {
            message.error({content:'文件读取失败！',style:{fontSize:"25px"}});
            meshLog('加载图片失败');
        };
    }

    //编辑框
    item1Change= (event) => {
        meshLog('item1',event.target.value);
        this.setState({ ui_mesh: event.target.value });
    };


    //取消
    closeBtnClick(){
        meshLog('取消');
        isLoad=0;
        this.props.onDataToParent("");
    };

    //保存
    saveBtnClick(){
        let name=this.state.ui_mesh;
        meshLog('name',name);
        if(name==""){
            message.warning({content:"Please input your Area name!",style:{fontSize:"25px"}});
            return;
        }

        if(isLoad==1){
            isLoad=2;
        }else{
            isLoad=0;
        }
        let buildingUUID=getSelectBuildingUUID(SPGet("SelectBuildingName"));
        
        if(isNew){
            this.createNewMesh(buildingUUID,name);
        }else{
            this.updateOldMesh(buildingUUID,name);
        }
    }


    //创建新Mesh
    createNewMesh(buildingUUID,name){
        if(judgeMeshNameExist(name,"")){
            message.warning({content:"Names exist",style:{fontSize:"25px"}});
            meshLog('Names exist');
            return;
        }
        createNewMesh(buildingUUID,name,Upload_Mesh);
        this.props.onDataToParent("");

    }
    //更新Mesh
    updateOldMesh(buildingUUID,name){
        if(judgeMeshNameExist(name,cur_mesh.meshName)){
            message.warning({content:"Names exist",style:{fontSize:"25px"}});
            meshLog('Names exist');
            return;
        }
        updateCurMesh(buildingUUID, cur_mesh.meshUUID, name);
        this.props.onDataToParent("");
    }

    render() {
        return (
            <div className="ui_dialog_bg">
                <div className="ui_grey_bg" />
                <div className="create_area_container"style={{left:(document.body.clientWidth-380)/2}}>
                    {/* 关闭按钮 */}
                    <img className='closeBtn' src={close_btn} onClick={() => { this.closeBtnClick() }}/>
                    {/* 1. Area Management 标题行 */}
                    <div className="area-row">
                        <div className="area-title">
                            <img className='icon' src={area}/>
                            <span>{this.state.mTitle}</span>
                        </div>
                    </div>

                    {/* 2. Create area 区域 */}
                    <Input className="item1" placeholder="*Area Name" value={this.state.ui_mesh} maxLength={15} onChange={this.item1Change}/>

                    <div className='areaBgSet'>   
                        <div className='loadImgBg'>
                            <img className="bg_image" src={this.state.load_img} draggable="false"/>
                        </div>

                        <Upload
                            className="img_uploader"
                            // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                            maxCount={1}
                            listType="picture" 
                            showUploadList={false}
                            beforeUpload={this.beforeUpload}
                            onChange={this.handleUploadChange}>
                                <img className="uploadBtn" src={upload_img} draggable="false"/>
                        </Upload>


                            
                        <span>Note: Only JPG/PNG formats are supported for Upload Plan View upload. The file size must be within 10MB, and the resolution should not exceed 2500×2500.</span>
                    </div>


                    {/* 底部按钮 */}
                    <div className="area-footer">
                        <button className='cancelBtn' onClick={() => { this.closeBtnClick() }}>Cancel</button>
                        <button className='okBtn' onClick={() => { this.saveBtnClick() }}>Confirm</button>
                    </div>

                
                </div>
            </div>
            
        );
    }
}
